/* globals lp, rxSwitchboard */
var _ = require('lodash');
var jQuery = require('jquery');
var ubBanzai = require('ub/control/banzai-features');

;(function(){
  lp.editor.ColorOverlayElement = function(containerPomElement){
    var $over = jQuery('<div class="lp-pom-color-overlay" style="position: absolute; width: 100%; height: 100%;"/>');

    if (containerPomElement.type === 'lp-pom-root') {
      $over.css('top', 0);
    }

    var containerModel = containerPomElement.model;
    var self = this;

    function _main() {
      var viewElement = containerPomElement.getViewDOMElement();
      jQuery(viewElement).prepend($over);
      self.changeSubscription = elementChangeEvs.ub_subscribe(_handleChangeEvent);
    }

    var elementChangeEvs = rxSwitchboard.subjects.jui_events
      .map(function(ev0){
        return _.merge(_.clone(ev0), {
          'type' : _cleanUpEventType(ev0),
          'id'   : _cleanupEventElementId(ev0)
        });
      })
      .filter(function(ev){
        return ev.id === containerPomElement.id &&
          !_.isElement(ev.data) &&
          _.contains(_.keys(_domainEvents), ev.type);
      });

    var _isOverlayApplicable = function() {
      var styleType = containerModel.getNewBackgroundStyleType();
      return _.contains(['image', 'pattern', 'video'], styleType);
    };

    var _cleanUpEventType = function(ev) {
      if (ev.data && ev.data.accessor && ev.data.accessor.startsWith('style.background')){
        return _.last(ev.data.accessor.split('.'));
      } else if(ev.data && ev.data.accessor && ev.data.accessor.startsWith('geometry')) {
        return _.last(ev.data.accessor.split('.'));
      } else {
        return ev.type;
      }
    };

    var _cleanupEventElementId = function(ev) {
      if (ev.data && ev.data.element) {
        return ev.data.element.id;
      } else if(ev.source && ev.source.element) {
        return ev.source.element.id;
      } else {
        return ev.id;
      }
    };

    var _handleChangeEvent = function(event) {
      var handler = _domainEvents[event.type];
      if (_.isFunction(handler)) {
        handler(event);
      }
      return event;
    };

    var _setOverlayBackground = function(){
      var background;
      if ( ! _isOverlayApplicable() ) {
        background = 'none';
      } else if (containerModel.getImageAboveColor()) {
        background = 'none';
      } else if (containerModel.getCurrentFillType() === 'gradient') {
        background = 'rgba(0,0,0,0)';
      } else if (containerModel.hasBackgroundColor()) {
        background = containerPomElement.getBGColorAsRGBA();
      } else {
        background = 'none';
      }
      $over.css('background', background);
    };

    var _setBorder = function() {
      var rules = [];

      if (! containerModel.exists('style.border')) {
        rules.push({attribute:'border-style', value: 'none'});
      } else {
        var value = containerModel.hasBorder() ?
          containerModel.get('style.border') : {width: 0};
        var borderApply = containerModel.getApplyBorder();

        var borderStyle = [
          borderApply.top ? value.style : 'none',
          borderApply.right ? value.style : 'none',
          borderApply.bottom ? value.style : 'none',
          borderApply.left ? value.style : 'none'
        ].join(' ');

        var overlayCSS = {
          top            : borderApply.top ? -value.width + 'px' : '0px',
          left           : borderApply.left ? -value.width + 'px' : '0px',
          'border-style' : borderStyle,
          'border-width' : value.width + 'px',
          'border-color' : _.isEmpty(value.color) ? 'none' : '#' + value.color.replace('#', '')
        };

        if (ubBanzai.features.isRemoveColorOverlayBordersEnabled()) {
          overlayCSS = {
            top: '0px',
            left: '0px'
          };
        }

        $over.css(overlayCSS);
      }
    };

    var _setCornerRadius = function() {
      if (containerModel.exists('geometry.cornerRadius')) {
        var radius = containerModel.get('geometry.cornerRadius');
        if (_.isObject(radius)) {
          var radiusToCssAttrMap = {
            tl:'border-top-left-radius',
            tr:'border-top-right-radius',
            bl:'border-bottom-left-radius',
            br:'border-bottom-right-radius'
          };
          _.each(radiusToCssAttrMap, function(cssAttr, modelAttr) {
            var radiusVal = radius[modelAttr];
            $over.css(cssAttr, radiusVal);
          });
        } else if (radius !== 0) {
          var borderWidth = 0;

          if (ubBanzai.features.isRemoveColorOverlayBordersEnabled()) {
            if (containerModel.exists('style.border.width')) {
              borderWidth = containerModel.get('style.border.width');
            }
          }

          $over.css('border-radius', radius - borderWidth);
        }
      }
    };

    var _domainEvents = {
      image           : _setOverlayBackground,
      opacity         : _setOverlayBackground,
      imageAboveColor : _setOverlayBackground,
      fillType        : _setOverlayBackground,
      backgroundColor : _setOverlayBackground,

      borderApply     : _setBorder,
      cornerRadius    : _setCornerRadius,

      resized: function() {
        _setOverlayBackground();
        _setBorder();
        _setCornerRadius();
      }

    };

    var overlayElement = {
      element: $over[0],
      changeEvents: this.changeSubscription,
    };

    _main();

    return overlayElement;
  };
})();



//////////////////
// WEBPACK FOOTER
// ./src/legacy/lp/editor/color_overlay_element.js
// module id = 1013
// module chunks = 0